import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/lib/auth";
import { AppShell } from "@/components/shell/AppShell";
import Home from "@/pages/Home";
import { Markets, Asset } from "@/pages/Markets";
import Alerts from "@/pages/Alerts";
import Learn from "@/pages/Learn";
import { Account, Pro } from "@/pages/AccountPro";
import PolymarketPage from "@/pages/PolymarketPage";
import PaymentResult from "@/components/PaymentResult";
import Predict from "@/pages/Predict";
import HandbookReader from "@/pages/Handbooks";
import Bots from "@/pages/Bots";
import Sports from "@/pages/Sports";
import LeaderboardPage from "@/pages/LeaderboardPage";
import AutoTrade from "@/pages/AutoTrade";
import Accounts from "@/pages/Accounts";
import Live from "@/pages/Live";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
        <Routes>
          <Route path="/payment/*" element={<PaymentResult />} />
          <Route path="*" element={
            <AppShell>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/markets" element={<Markets />} />
                <Route path="/asset/:id" element={<Asset />} />
                <Route path="/polymarket" element={<PolymarketPage />} />
                <Route path="/alerts" element={<Alerts />} />
                <Route path="/learn" element={<Learn />} />
                <Route path="/learn/:topic/:level" element={<HandbookReader />} />
                <Route path="/predict" element={<Predict />} />
                <Route path="/admin" element={<Bots />} />
                <Route path="/bots" element={<Navigate to="/admin" replace />} />
                <Route path="/sports" element={<Sports />} />
                <Route path="/auto" element={<AutoTrade />} />
                <Route path="/accounts" element={<Accounts />} />
                <Route path="/live" element={<Live />} />
                <Route path="/leaderboard" element={<LeaderboardPage />} />
                <Route path="/account" element={<Account />} />
                <Route path="/pro" element={<Pro />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <footer className="text-center text-[11px] text-slate-600 pt-10">BTC Odds Watch · Educational market data, not financial advice · Prices: Coinbase, CoinGecko, Polymarket US</footer>
            </AppShell>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
